<ng-container *ngIf="isOtpService==false">
<app-not-refresh-appbar >OTP {{formPage}}</app-not-refresh-appbar>
    <!-- App Capsule -->
    <div id="appCapsule">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h5 class="text-white">{{ 'otpdescription' | translate}}</h5>
                    <h4 class="text-white font-weight-bold"> {{phoneNumber}}</h4>
                    <h5 class="text-white">{{ 'otptitle' | translate}}</h5>                    
                </div>
                <div class="col-12">
                    <code-input [isCodeHidden]="false" [codeLength]="6" (codeChanged)="onCodeCompleted($event)"
                    (keyup.enter)="validateOtp()" class="text-white"></code-input>
                    <p id="passErr" class="text-warning text-center mt-3"></p>
                    <div class="counterTimer" *ngIf="counterTimer >0">{{counterTimer}}</div>
                     <button type="button" class="btn btn-primary float-right" (click)="showChannelList()"
                        *ngIf="counterTimer == 0">Resend OTP</button>
                </div>
            </div>           
            <div class="row justify-content-center">
                    <button type="button" class="btn btn-primary"
                        (click)="actionType == 'NEWDIVICE'? getNewDeviceOtp(): checkOtp()">{{ 'next' | translate}}</button>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <h5 class="text-white font-weight-bold text-center" (click)="goToServicePhone()">
                        {{'code_err_msg' | translate}} {{'help' | translate}}
                    </h5>
                </div>    
            </div>
        </div>
    </div>   
</ng-container>
<ng-container *ngIf="isOtpService==true"> 
   <share-app-otpsetting (backemit)="showOptPage($event)"></share-app-otpsetting>
    <!-- <app-otp-service-phone (backemit)="showOptPage($event)"></app-otp-service-phone> -->
</ng-container>

<ng-template #otpSettingAlert>  
  <div class="modal-body">   
    <div class="container p-0">
     <div class="container">        
        <h3 class="text-center mt-3">{{'otp_setting_desc' | translate }}</h3>
            <!-- {{ otpChannelList | json}} -->
        <div class="row">
            <div class="col-12 mt-2 otp__setting" *ngFor="let otpChannel of otpChannelList;trackBy: trackByOtpChannelList">
                <div class="card">
                    <div class="card-body text-center" [ngClass]="{'active': otpChannel.channel_id === selectedChannel.channel_id}"
                     (click)="onSelectOtpChannel(otpChannel)">   
                           <img [src]="otpChannel.icon_url" class="img-fluid" alt="icon" style="width: 40px; height: 40px;" />
                           <div class="ml-2 text-left">
                                <h4>{{otpChannel.channel_name}}</h4>
                                <p *ngIf="otpChannel.channel_code === 'SMS'">{{ 'sms_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'VIBER'">{{ 'viber_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'TELEGRAM'">{{ 'telegram_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'EMAIL'">{{ 'email_des' | translate : {value: otpChannel.destination_masked== null?'******@gmail.com': otpChannel.destination_masked} }}   </p>
                                <div class="mb-3" *ngIf="otpChannel.channel_code === 'EMAIL' && otpChannel.destination === null && otpChannel.channel_id === selectedChannel.channel_id">
                                    <label for="exampleInputEmail1" class="form-label">Email address</label>             
                                    <input type="email" class="form-control" placeholder="Enter your email"  name="email"
                                     [(ngModel)]="email"  #emailRef="ngModel" (input)="checkEmail(emailRef)" />                                    
                                      <div *ngIf="emailRef.invalid && emailRef.touched" class="error-color">{{ 'invalid_email' | translate }}</div>                    
                                </div>
                            </div>
                           
                                      
                    </div>
                </div>
            </div>         
        </div>
        <p class="text-center mt-3">{{'otp_setting_desc1' | translate : {value: selectedChannel.channel_name} }}</p>
        <button class="btn btn-primary btn-block mt-3" (click)="sendChannelByOtp()">{{ 'send' | translate }}</button>

    </div> 
    </div>
  </div>
  <!-- <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="openGame('free')">{{ 'game_view' |
      translate}}</button>
    <button type="button" class="btn btn-primary" (click)="goToGameWallet()">{{ 'game_balance_transfer' |
      translate}}</button>
  </div> -->

</ng-template>
<!-- * App Capsule -->
<!-- 
    <ngx-spinner bdColor = "rgb(6,56,107)" size = "large" color = "#fff" type = "ball-spin-clockwise" [fullScreen] = "true"></ngx-spinner> -->